import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper';
import "swiper/css";
import "swiper/css/pagination";

export default class extends Controller {
  static targets = ["container"]
  static values = {
    containerClass: { type: String, default: "swiper" },
    nextButtonClass: { type: String, default: "swiper-button-next" },
    prevButtonClass: { type: String, default: "swiper-button-prev" },
    loop: { type: Boolean, default: false },
    nestedCarousel: { type: String, default: '' },
    slidesPerView: { type: Number, default: 1 },
    spaceBetween: { type: Number, default: 0 }
  }

  connect() {
    const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
    this.swiper = new Swiper(`.${this.containerClassValue}`,
      {
        loop: this.loopValue,
        spaceBetween: this.spaceBetweenValue * remInPx,
        slidesPerView: this.slidesPerViewValue
      }
    )
  }

  slideNext (){
    this.swiper.animating = false
    this.swiper.slideNext()
    this.toggleNestedCaoursel()
  }

  slidePrev (){
    this.swiper.animating = false
    this.swiper.slidePrev()
    this.toggleNestedCaoursel()
  }

  getNestedSwiper() {
    const nestedCarousel = document.querySelector(`.${this.nestedCarouselValue}`)
    if(nestedCarousel == null) { return null }
    return nestedCarousel.swiper
  }

  toggleNestedCaoursel() {
    if(this.nestedCarouselValue != '') { 
      const nestedSwiper = this.getNestedSwiper()
      nestedSwiper.slideToLoop(this.swiper.realIndex)
    }
  }
}
